import { useTranslation } from 'react-i18next';
import { LiliNumberInput, Text } from '@lili/lili-frontend-common';
import { CustomRadioButton } from '@Components/inputs/RadioButton/CustomRadioButton';
import { FieldError } from '@Components/inputs/FieldError';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import { EddYesNo } from '@Pages/happyFlowPages/eddQuestions/consts';

export const CashPaymentsForm = () => {
  const { t } = useTranslation('eddQuestions');

  return (
    <div className='flex flex-col gap-[16px] mt-[16px]'>
      <ControllerWrapper name={EddEmbeddedFields.EDD_CASH_PAYMENTS}>
        {({ onChange, value, error }) => {
          const isYesSelected = value === EddYesNo.YES;

          return (
            <>
              <CustomRadioButton
                label={t('organic.cashPayments.no')}
                value={EddYesNo.NO}
                inputId='cash-payments-no'
                onChange={onChange}
                checked={value === EddYesNo.NO}
                name={EddEmbeddedFields.EDD_CASH_PAYMENTS}
              />
              <CustomRadioButton
                label={t('organic.cashPayments.yes')}
                value={EddYesNo.YES}
                inputId='cash-payments-yes'
                onChange={onChange}
                checked={value === EddYesNo.YES}
                name={EddEmbeddedFields.EDD_CASH_PAYMENTS}
              />

              {isYesSelected && (
                <div className='flex flex-col gap-2 mt-[-8px]'>
                  <Text.H9>{t('organic.cashPayments.percentagePrompt')}</Text.H9>
                  <div className={'w-[288px]'}>
                    <ControllerWrapper name={EddEmbeddedFields.EDD_CASH_PAYMENTS_PERCENTAGE}>
                      {({
                        onChange: onPercentChange,
                        value: percentValue,
                        error: percentError,
                        onBlur,
                      }) => (
                        <LiliNumberInput
                          value={percentValue}
                          onChange={onPercentChange}
                          errorMessage={percentError?.message}
                          title={t('organic.cashPayments.percentagePlaceholder')}
                          onBlur={onBlur}
                          id={EddEmbeddedFields.EDD_CASH_PAYMENTS_PERCENTAGE}
                          min={0}
                          max={100}
                          suffix='%'
                          maxLength={3}
                          isPublic
                        />
                      )}
                    </ControllerWrapper>
                  </div>
                </div>
              )}
              <FieldError error={error} testId={`${EddEmbeddedFields.EDD_CASH_PAYMENTS}-error`} />
            </>
          );
        }}
      </ControllerWrapper>
    </div>
  );
};
